import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation, Link } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Navbar } from "./components/layout/Navbar";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import MockTestEngine from "./pages/MockTestEngine";
import TestTaking from "./pages/TestTaking";
import Leaderboard from "./pages/Leaderboard";
import AICoach from "./pages/AICoach";
import Settings from "./pages/Settings";

import StudyGuides from "./pages/StudyGuides";
import AdminDashboard from "./pages/AdminDashboard";
import Legal from "./pages/Legal";

import AuthCallback from "./pages/AuthCallback";

const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-background flex items-center justify-center text-primary font-heading text-2xl tracking-widest animate-pulse">INITIALIZING SYSTEM...</div>;
  if (!user) return <Navigate to="/login" />;
  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Navbar />
      <main className="flex-1 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
};

const PublicRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-background flex items-center justify-center text-primary font-heading text-2xl tracking-widest animate-pulse">INITIALIZING SYSTEM...</div>;
  if (user) return <Navigate to="/dashboard" />;
  return <Outlet />;
};

function AppRouter() {
  const location = useLocation();
  // Check URL fragment (not query params) for session_id
  if (location.hash?.includes('session_id=')) { 
    return <AuthCallback />; 
  }
  return (
    <>
      <Routes>
        <Route element={<PublicRoute />}>
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
        </Route>
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/tests" element={<MockTestEngine />} />
          <Route path="/mock-test/:id" element={<TestTaking />} />
          <Route path="/leaderboard" element={<Leaderboard />} />
          <Route path="/coach" element={<AICoach />} />
          <Route path="/guides" element={<StudyGuides />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Route>
        {/* Publicly accessible legal routes (with navbar injected) */}
        <Route element={<div className="min-h-screen bg-background flex flex-col"><Navbar /><main className="flex-1 overflow-x-hidden pb-12"><Outlet /></main></div>}>
          <Route path="/legal" element={<Legal />} />
        </Route>
      </Routes>
      
      {/* Global Government Disclaimer Sticky Footer */}
      <div className="bg-destructive text-white text-[10px] sm:text-xs font-bold text-center py-2 px-4 tracking-widest uppercase z-50 fixed bottom-0 w-full shadow-[0_-4px_10px_rgba(0,0,0,0.5)]">
        DISCLAIMER: NOT AFFILIATED WITH ANY GOVERNMENT ENTITY. <Link to="/legal" className="underline hover:text-black">VIEW OFFICIAL SOURCES</Link>.
      </div>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;